export const saveRollDiceCount = (opportunity) => ['advantage', 'disadvantage'].includes(opportunity?.targetSave?.rollMode) ? 2 : 1;

export const selectSaveD20 = (dice, rollMode = 'normal') => {
  const count = ['advantage', 'disadvantage'].includes(rollMode) ? 2 : 1;
  if (!Array.isArray(dice) || dice.length !== count || dice.some((value) => !Number.isInteger(value) || value < 1 || value > 20)) throw new Error('Save dice evidence was unavailable.');
  return rollMode === 'advantage' ? Math.max(...dice) : rollMode === 'disadvantage' ? Math.min(...dice) : dice[0];
};
